import { z } from 'zod';

/**
 * Scraping system types
 */
var ScrapeJobType;
(function (ScrapeJobType) {
    ScrapeJobType["ALL_INVENTORY_SYNC"] = "ALL_INVENTORY_SYNC";
    ScrapeJobType["INVENTORY_ITEM_SYNC"] = "INVENTORY_ITEM_SYNC";
    ScrapeJobType["INITIAL_SITE_INDEX"] = "INITIAL_SITE_INDEX";
    ScrapeJobType["CANON_VEHICLE_IMAGE_SCRAPING"] = "CANON_VEHICLE_IMAGE_SCRAPING";
    ScrapeJobType["MACRO_INFO_SCRAPE"] = "MACRO_INFO_SCRAPE";
    // For SEO/GEO project
    ScrapeJobType["VEHICLE_DETAILS_PAGE_SCRAPING"] = "VEHICLE_DETAILS_PAGE_SCRAPING";
})(ScrapeJobType || (ScrapeJobType = {}));
const WebsiteProvider = {
    DEALER_SPIKE: 'DEALER_SPIKE',
    PIXEL_MOTION: 'PIXEL_MOTION',
    DEALER_ACCELERATE: 'DEALER_ACCELERATE',
    MOTION: 'MOTION',
    OTHER: 'OTHER',
};
const websiteProviderValues = [
    WebsiteProvider.DEALER_SPIKE,
    WebsiteProvider.PIXEL_MOTION,
    WebsiteProvider.DEALER_ACCELERATE,
    WebsiteProvider.MOTION,
    WebsiteProvider.OTHER,
];
const WebsiteProviderSchema = z.enum(websiteProviderValues);
var JobStatus;
(function (JobStatus) {
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["COMPLETE_SUCCESS"] = "COMPLETE_SUCCESS";
    JobStatus["COMPLETE_FAILED"] = "COMPLETE_FAILED";
})(JobStatus || (JobStatus = {}));

export { JobStatus, ScrapeJobType, WebsiteProvider, WebsiteProviderSchema, websiteProviderValues };
//# sourceMappingURL=Scraping.js.map
